import { useEffect } from "react";
import { useAuth } from "react-oidc-context";

import { setAccessToken } from "@/lib/api/client";

/**
 * Mirrors the OIDC user's access token into the API client's process-level
 * holder. Mounting this inside the AuthProvider makes every React Query
 * fetch automatically authenticated.
 */
export function AuthTokenSync() {
  const auth = useAuth();

  useEffect(() => {
    setAccessToken(auth.user?.access_token ?? null);
  }, [auth.user?.access_token]);

  return null;
}
